import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {
    MatInputModule, MatButtonModule, MatSelectModule, MatMenuModule, MatTableModule,
    MatPaginatorModule, MatSortModule, MatDialogModule, MatDatepickerModule, NativeDateAdapter,
    MatProgressSpinnerModule, MatSlideToggleModule, MatSnackBarModule, MatIconModule, MatCheckboxModule,
    MatPaginatorIntl, MatProgressBarModule
} from '@angular/material';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AppRoutingModule} from "../../app-routing.module";
/*import {
    NewEventDialog, PopulateNewEventDialog, RegistantDialog, DeleteRegistantDialog,
    DeleteEventDialog, EmailEditDialogComponent, PreviewDialogComponent, CustomUidsDialog
} from './components/dialogs';*/
import {PaymentService} from "../../payment/payment.service";
import {SharedModule} from "../../shared/shared.module";
import { HttpClientModule } from '@angular/common/http';
import {TimePipe} from "../../shared/time.pipe";
import {AccountComponent} from "./account.component";
import {UserDetailsComponent} from "./components/user-details";
import {BillingComponent} from "./components/billing";
import {EmailSettingsComponent} from "./components/email-settings";
import {SubscriptionsComponent} from "./components/subscriptions";
import {
    PaymentDialog, PaymentSummaryDialog, PaymentSourceDeleteDialog
} from "./components/dialogs";
import {TaxService} from "../../payment/taxes.service";
import {PaymentHistoryComponent} from "./components/history";

/**
 * Created by greg on 27/02/2018.
 */

@NgModule({
    imports: [
        CommonModule,
        AppRoutingModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatMenuModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatDialogModule,
        MatButtonModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatIconModule,
        MatCheckboxModule,
        MatProgressBarModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        HttpClientModule

    ],
    declarations: [AccountComponent, UserDetailsComponent, BillingComponent, PaymentHistoryComponent, EmailSettingsComponent, SubscriptionsComponent, PaymentSummaryDialog, PaymentSourceDeleteDialog, PaymentDialog],
    providers:[PaymentService, TaxService, NativeDateAdapter, MatPaginatorIntl, TimePipe],
    entryComponents:[PaymentDialog, PaymentSummaryDialog, PaymentSourceDeleteDialog]
})
export class AccountModule { }


// WEBPACK FOOTER //
// ./src/app/pages/account/account.module.ts